import { Component, OnInit } from '@angular/core';
import { OrgService } from '../_services/org.service';
import { PhaseService } from '../_services/phase.service';
import { Subscription } from 'rxjs';
import { Classroom } from 'src/app/dropdown-classroom/org.classroom';
@Component({
	selector: 'app-dashboard-admin',
	templateUrl: './dashboard-admin.component.html',
})
export class DashboardAdminComponent implements OnInit {
	node: any;
	phases: any;
	classrooms: Classroom[] = [];
	constructor(public orgService: OrgService, public phaseService: PhaseService) {}
	gridApi = [];
	list: any;
	nodes: any[] = [];
	selectedNode: any;
	public downLoadingNotes = false;
	public isCollapsed = false;
	public selectedSchool;
	public selectedClassroom;
	public selectedDistrict;
	totalNotes = 0;
	totalScores = 0;
	subscriptions: Subscription[] = [];
	ngOnInit(): void {
		this.orgService.init();

		this.subscriptions.push(
			this.orgService.selectedDistrict$.subscribe((data: any) => {
				console.log('selectedDistrict', data);
				this.orgService.tree$(data.districtId).subscribe((data: any) => {
					this.list = [data];
					this.nodes = [data];
					if (this.list.length > 0) {
						this.list[0].expanded = true;
					}
					if (this.nodes.length > 0) {
						this.nodes[0].expanded = true;
					}
				});
			})
		);

		this.subscriptions.push(
			this.orgService.selectedSchool$.subscribe((data: any) => {
				//any school data change will get graph data.
				this.selectedSchool = data;
				console.log('selectedSchool', data);
			})
		);

		this.subscriptions.push(
			this.orgService.selectedClassroom$.subscribe((data: any) => {
				this.selectedClassroom = data;
				console.log('selectedClassroom', data);
			})
		);
		this.subscriptions.push(
			this.orgService.classrooms$.subscribe((data: Classroom[]) => {
				this.classrooms = data;
				console.log('this.classrooms', this.classrooms);
			})
		);
	}

	nodeChange(node: any) {
		console.log('node', node);
		console.log('orgService.orgs', this.orgService.orgs);
		this.selectedNode = node;
		if (!node || !this.orgService.orgs) {
			return;
		}

		// Check if node matches an area (typeId == '13')
		if (node.typeId == '13') {
			const matchingArea = this.orgService.orgs.areas?.find((area: any) => area.id == node.id);
			console.log('matchingArea', matchingArea ? matchingArea.id : 'none', '==', node.id);
			if (matchingArea) {
				this.orgService.setArea(matchingArea, false);
			}
		}

		if (node.typeId == '6') {
			const matchingArea = this.orgService.orgs.areas?.find((area: any) => area.id == node.parentId);
			const matchingSchool = this.orgService.orgs.schools?.find((school: any) => school.id == node.id);
			if (matchingArea) {
				this.orgService.setArea(matchingArea, false);
				this.orgService.setSchool(matchingSchool);
			} else {
				console.log('no matching area found');
			}
		}
	}
}
